import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Set the document title to match the blog post
document.title = 'Sofias Hälsoblogg - Min resa mot ett lättare liv';
// Add meta tags for better caching
const metaCache = document.createElement('meta');
metaCache.setAttribute('http-equiv', 'Cache-Control');
metaCache.setAttribute('content', 'no-cache, no-store, must-revalidate');
document.head.appendChild(metaCache);
const metaPragma = document.createElement('meta');
metaPragma.setAttribute('http-equiv', 'Pragma');
metaPragma.setAttribute('content', 'no-cache');
document.head.appendChild(metaPragma);
const metaExpires = document.createElement('meta');
metaExpires.setAttribute('http-equiv', 'Expires');
metaExpires.setAttribute('content', '0');
document.head.appendChild(metaExpires);
// Add Taboola Tracking Pixel
const taboolaScript = document.createElement('script');
taboolaScript.type = 'text/javascript';
taboolaScript.innerHTML = `
  window._tfa = window._tfa || [];
  window._tfa.push({notify: 'event', name: 'page_view', id: 1912203});
  !function (t, f, a, x) {
    if (!document.getElementById(x)) {
      t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
    }
  }(document.createElement('script'),
  document.getElementsByTagName('script')[0],
  '//cdn.taboola.com/libtrc/unip/1912203/tfa.js',
  'tb_tfa_script');
`;
document.head.appendChild(taboolaScript);
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<React.StrictMode data-id="element-263">
      <App data-id="element-264" />
    </React.StrictMode>);
} else {
  console.error('Root element not found');
}